import { VehicleFilters } from "../features/Filters/VehicleFilters";

export const AffiliateVehiclesActions = () => {
  return (
    <div className="pb-3 pt-2">
      <VehicleFilters.ActiveFilters />
    </div>
  );
};
